import React from 'react';
import StatTile from '../common/StatTile';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT } from '../../utils/format';

export default function StatsSix() {
  const { basic, extended, activeDirects, teamCount, directBusiness, teamBusiness } = useContractState();
  return (
    <div className="six-stat-grid">
      <StatTile label="Total Invested" value={formatUSDT(basic && basic.totalInvestment)} />
      <StatTile label="Total Earned"   value={formatUSDT(basic && basic.totalEarned)} />
      <StatTile label="Active Directs" value={activeDirects || 0} delta={extended ? `of ${extended.directReferrals}` : ''} />
      <StatTile label="Total Team"     value={teamCount || 0} />
      <StatTile label="Direct Business" value={formatUSDT(directBusiness)} />
      <StatTile label="Team Business"   value={formatUSDT(teamBusiness)} />
    </div>
  );
}
